
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { PartnerResultsTypes } from "state/types/UserTypes";
import { CurrentPeriod } from "types/CurrentPeriod";
import { PortalGlampartners } from "views/pages/PortalGlampartners";

// ----------------------------------------------------------------------

export const PartnerResultsActions = {};

// THUNKS
// Status------------------------------------------------------------------

 

PartnerResultsActions.getCurrentResults = () => {
  return async (dispatch, getState) => {

    const state = getState();

    let {
      data
    } = state.token;

    let currentPeriod = new CurrentPeriod();
 

      await ExecuteRequest(
      GlamboxEndpoints.Partner.getCurrentResults,
      {
        period: currentPeriod.period
      },
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;
          
        if(result.resultados != null){
            
            result.resultados.loaded = true;
            console.log(result.resultados);
            dispatch(PartnerResultsActions.set(result.resultados));

        }else{
          result.resultados = {
            glamboxPayment: 0,
            glamshopPayment: 0,
            b4APayment: 0,
            totalToPay: 0,
            loaded: true
          }
          dispatch(PartnerResultsActions.set(result.resultados));

        }
        
        console.log(result.resultados);
        // dispatch(PartnerResultsActions.set(result.resultados));

      })
  
  }


}


PartnerResultsActions.error = (error) => ({
  partnerResults: {
    error
  },
  type: PartnerResultsTypes.error
});

PartnerResultsActions.set = (partnerResults) => ({
  partnerResults: {
    data: partnerResults,
    lastSync: Date.now()
  },
  type: PartnerResultsTypes.set
});